import type {
  ProjectSelectorComparisonAction,
  ProjectSelectorProjectAction,
  SelectedComparison,
  SelectedProject
} from "./project-selector.types"

export const PROJECT_SELECTOR_SELECT_PROJECT: string = "PROJECT_SELECTOR_SELECT_PROJECT"
export const PROJECT_SELECTOR_DESELECT_PROJECT: string = "PROJECT_SELECTOR_DESELECT_PROJECT"
export const PROJECT_SELECTOR_SELECT_COMPARISON: string = "MAP_SELECTOR_SELECT_COMPARISON"
export const PROJECT_SELECTOR_DESELECT_COMPARISON: string = "MAP_SELECTOR_DESELECT_COMPARISON"

export function projectSelectorSelectProject(project: SelectedProject): ProjectSelectorProjectAction {
  return { type: PROJECT_SELECTOR_SELECT_PROJECT, payload: project }
}

export function projectSelectorDeselectProject(project: SelectedProject): ProjectSelectorProjectAction {
  return { type: PROJECT_SELECTOR_DESELECT_PROJECT, payload: project }
}
export function projectSelectorSelectComparison(comparison: SelectedComparison): ProjectSelectorComparisonAction {
  return { type: PROJECT_SELECTOR_SELECT_COMPARISON, payload: comparison }
}

export function projectSelectorDeselectComparison(comparison: SelectedComparison): ProjectSelectorComparisonAction {
  return { type: PROJECT_SELECTOR_DESELECT_COMPARISON, payload: comparison }
}
